import React from 'react'

export default () => (
  <div id="features" className="features-pane">
    <div className="feature">
      <img src="https://statics.streamable.com/static/landing/animations/upload-animation.gif"/>
      <div className="info">
        <h2>Upload and share your videos instantly</h2>
        <p>The fastest video uploader on the web — don't take our word for it, try it! After your videos are uploaded, stream in 4K UHD (60fps). No home theater necessary.</p>
      </div>
    </div>
    <div className="feature">
      <div className="info" style={{marginLeft:'auto'}}>
        <h2>Video editing that gets out of your way</h2>
        <p>With one-click resizing to landscape, square, or vertical formats, you can get back hours of time while creating videos for every platform and channel.</p>
      </div>
      <img src="https://statics.streamable.com/static/landing/animations/edit-animation.gif"/>
    </div>
  </div>
)
